import { render, staticRenderFns } from "./leftRightEarOptions.vue?vue&type=template&id=4ba74d8c&scoped=true&"
import script from "./leftRightEarOptions.vue?vue&type=script&lang=js&"
export * from "./leftRightEarOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba74d8c",
  null
  
)

export default component.exports